import React from 'react'
import { connect } from 'react-redux'
import converter from 'length-distance-converter'

const toggleDistanceFormat = () => ({
  type: 'TOGGLE_DISTANCE_FORMAT',
})

const postFixMap = {
  meter: `m`,
  feet: `"`,
  yard: `yd`,
}

function Distance({
  distance,
  distanceFormat = 'meter',
  addPostfix = true,
  spacePostfix = true,
  dispatch,
}) {
  const renderDistance = () => {
    switch (distanceFormat) {
      case 'feet':
        return converter.metersToFeet(distance)
      case 'yard':
        return converter.metersToYard(distance)
      default:
        return distance
    }
  }

  const renderPostFix = () => {
    if (!addPostfix) return ''

    return (spacePostfix ? ' ' : '') + postFixMap[distanceFormat]
  }

  if (!distance) return null

  return (
    <span className="distance" onClick={() => dispatch(toggleDistanceFormat())}>
      {Math.round(renderDistance()).toLocaleString() + renderPostFix()}
    </span>
  )
}

const mapStateToProps = (state) => {
  return {
    distanceFormat: state.distanceFormat,
  }
}

export default connect(mapStateToProps)(Distance)
